import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Flex, Tooltip } from '@chakra-ui/react';
import { updateAnswers } from 'store/rootReducer/reducer';
import { TStore } from 'types/general.types';
import { TStrengths } from './types';

export function Strengths({
  currentEvalutaionData,
  gray,
}: {
  currentEvalutaionData: any;
  gray?: boolean;
}) {
  const answers = useSelector((state: TStore) => state.survey.answers);
  const dispatch = useDispatch();
  const { name, strengths } = currentEvalutaionData;
  const currentAnswers = answers[name].value;

  const handleActiveStrenghts = (id: number) => {
    if (currentAnswers?.some((a: any) => a.id === id)) {
      const newArray = currentAnswers.filter((item: any) => item.id !== id);
      dispatch(
        updateAnswers({
          name,
          value: newArray,
        }),
      );
    } else {
      dispatch(
        updateAnswers({
          name,
          value: [
            {
              id,
              chosenAt: new Date().toISOString(),
            },
            ...currentAnswers,
          ],
        }),
      );
    }
  };

  const getColor = (item: any) => {
    if (gray) {
      return '#A4A4A4';
    }
    return currentAnswers?.some((a: any) => a.id === item.id) ? '#FFF' : '#0C0C0C';
  };

  const getTooltipColor = (item: any) => {
    if (gray) {
      return '#A4A4A4';
    }
    return currentAnswers?.some((a: any) => a.id === item.id) ? '#BEAAF8' : '#8A69EA';
  };

  const getBgColor = (item: any) => {
    if (gray) {
      return '#FFF';
    }
    return currentAnswers?.some((a: any) => a.id === item.id) ? '#8A69EA' : 'transparent';
  };

  const getBorderColor = (item: any) => {
    if (gray) {
      return '1px solid #A4A4A4';
    }
    return currentAnswers?.some((a: any) => a.id === item.id)
      ? '1px solid #5431B7'
      : '1px solid #BEAAF8';
  };

  return (
    <Box>
      <Grid
        templateColumns={{ base: 'repeat(3, 1fr)', lg: 'repeat(4, 1fr)' }}
        gap={{ base: 4, lg: 8 }}
      >
        {strengths.map((item: TStrengths, index: string) => (
          <Flex
            textAlign="center"
            padding="4px"
            fontWeight="500"
            minWidth="105px"
            minHeight="105px"
            width="100%"
            height="123px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            position="relative"
            borderRadius="2px"
            backgroundColor={getBgColor(item)}
            color={getColor(item)}
            border={getBorderColor(item)}
            cursor="pointer"
            transition=".3s"
            _hover={{
              backgroundColor: currentAnswers?.some((a: any) => a.id === item.id)
                ? '#5431B7'
                : '#F0EDF9',
              borderColor: '#5431B7',
              color: currentAnswers?.some((a: any) => a.id === item.id) ? '#FFF' : '#000',
            }}
            key={item.id}
            onClick={() => handleActiveStrenghts(item.id)}
            data-testid={`strength-item-${index}`}
          >
            <div>{item.name}</div>
            <Tooltip
              hasArrow
              label={item.tooltip}
              placement="top"
              backgroundColor="#000"
              borderRadius="0"
              p="12px"
            >
              <Flex position="absolute" top="10px" right="10px">
                <svg
                  width="20"
                  height="18"
                  viewBox="0 0 20 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.30729 10.504H10.6633V10.132C10.6633 8.668 12.7513 8.692 12.7513 6.664C12.7513 5.296 11.7673 4.36 10.0873 4.36C8.40729 4.36 7.32729 5.296 7.32729 7.012V7.18H8.64729V7.012C8.64729 6.232 9.12729 5.536 10.0753 5.536C10.9753 5.536 11.3953 6.196 11.3953 6.808C11.3953 8.188 9.30729 8.128 9.30729 10.144V10.504ZM9.97929 13.12C10.4113 13.12 10.7473 12.796 10.7473 12.34C10.7473 11.884 10.4113 11.572 9.97929 11.572C9.54729 11.572 9.19929 11.884 9.19929 12.34C9.19929 12.796 9.54729 13.12 9.97929 13.12Z"
                    fill={getTooltipColor(item)}
                  />
                </svg>
              </Flex>
            </Tooltip>
          </Flex>
        ))}
      </Grid>
    </Box>
  );
}

Strengths.defaultProps = {
  gray: false,
};
